import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Globals } from 'app/_globals';
import { NotificationService } from 'app/_services/notification.service';
import { SiteOwnerUserService } from 'app/_services/site-owner-user.service';

@Component({
  selector: 'app-competency-reports',
  templateUrl: './competency-reports.component.html',
})
export class CompetencyReports implements OnInit {

  private routeRole: string;
  public isAdminUser: boolean;
  private isSiteOwner: boolean;
  public isPowerStationUser: boolean;

  public siteOwners = [];
  public selectedSiteOwner;
  public siteOwnerId: any;

  public showConfinedSpaceCard: boolean;

  constructor(
    private globals: Globals,
    private router: Router,
    private siteOwnerUserService: SiteOwnerUserService,
    private notificationService: NotificationService,
  ) {
    this.routeRole = globals.user.routeRole;
  }

  ngOnInit() {
    this.isSiteOwner = this.routeRole === 'site-owner';
    this.isPowerStationUser = this.routeRole === 'power-station-owner';
    this.isAdminUser = (this.routeRole === 'admin' || this.routeRole === 'support');

    if (this.isSiteOwner || this.isPowerStationUser) {
      this.siteOwnerId = this.globals.siteOwnerUsers[0].skylarkUserId;
    } else if (this.isAdminUser) {
      this.getSiteOwnersList();
    } else {
      setTimeout(() => {
        this.notificationService.notify('danger', 'Error', 'Not implemented for this user type');
      });
    }
  }

  private getSiteOwnersList() {
    this.siteOwnerUserService.getAllEnabledSiteOwnersForDropdowns().subscribe((result: any) => {
      this.siteOwners = result.map(item => ({
        label: item.firstName + ' ' + item.lastName,
        value: item
      }));
    });
  }

  public selectedSiteOwnerChange() {
    this.siteOwnerId = this.selectedSiteOwner && this.selectedSiteOwner.id;

    let powerStation = 'Energia-Huntstown'

    if (this.selectedSiteOwner.firstName === powerStation)
      this.showConfinedSpaceCard = true;
    if (this.selectedSiteOwner.firstName != powerStation)
      this.showConfinedSpaceCard = false;
  }

  public goToOutages() {
    this.router.navigate(['/', this.routeRole, 'training']);
  }
}
